var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:ring"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.5 22.9167L18.3333 10.0833L22 4.58334H33L36.6667 10.0833L27.5 22.9167ZM35.5208 15.5833L32.7708 19.4792C37.8125 21.5417 41.25 26.3542 41.25 32.0833C41.25 35.7301 39.8014 39.2274 37.2227 41.8061C34.6441 44.3847 31.1467 45.8333 27.5 45.8333C23.8533 45.8333 20.3559 44.3847 17.7773 41.8061C15.1987 39.2274 13.75 35.7301 13.75 32.0833C13.75 26.3542 17.1875 21.5417 22.2292 19.4792L19.4792 15.5833C13.2917 18.5625 9.16667 24.75 9.16667 32.0833C9.16667 36.9456 11.0982 41.6088 14.5364 45.047C17.9745 48.4851 22.6377 50.4167 27.5 50.4167C32.3623 50.4167 37.0255 48.4851 40.4636 45.047C43.9018 41.6088 45.8333 36.9456 45.8333 32.0833C45.8333 24.75 41.7083 18.5625 35.5208 15.5833Z",
    fill: "#DB9E30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.bc5e98b065ba4255754301cbe563b8a4.svg";
export { ForwardRef as ReactComponent };